import { render, staticRenderFns } from "./Form513_v2.vue?vue&type=template&id=36c6974a&scoped=true&"
import script from "./Form513_v2.vue?vue&type=script&lang=js&"
export * from "./Form513_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form513_v2.vue?vue&type=style&index=0&id=36c6974a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6974a",
  null
  
)

export default component.exports